export const EVENT_QUESTION_STATUS = {
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  PENDING: 'PENDING',
};
export const DEFAULT_BONUS_MULTIPLIER = 2;
